module.exports = __webpack_public_path__ + "static/media/demo1.d872e500.PNG";